import { ReauthenticatableClient } from "@payleo/auth/clients";
import { JURL } from "../utils.js";
export class ImaraClient extends ReauthenticatableClient {
    constructor(auth, baseUrl) {
        super(auth);
        this.url = new JURL(baseUrl).joinPath("/imara");
    }
    joinPath(...paths) {
        return this.url.joinPath(...paths).href;
    }
}
